import { AppFooter } from '@teliaee/telia-megamenu';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import config from '../../config';
import { ILanguageStore } from '../../stores/LanguageStore';

interface IFooterContainerProps {
  languageStore?: ILanguageStore;
}

@inject('languageStore')
@observer
export default class FooterContainer extends React.Component<IFooterContainerProps> {
  public render(): JSX.Element {
    return <AppFooter app="selfservice" brand="diil" tier={config.headerEnvironmentName} lang={this.props.languageStore.currentLanguage} />;
  }
}
